// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3rbuz","amount":"Amount_amount__3VgdJ","tip":"Amount_tip__1yX-D","tipHeader":"Amount_tipHeader__1kNda","tipsWrap":"Amount_tipsWrap__XdeiR"};